import { render } from "./SearchItem.vue?vue&type=template&id=3877ac80&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=ts"
export * from "./SearchItem.vue?vue&type=script&lang=ts"

import "./SearchItem.vue?vue&type=style&index=0&id=3877ac80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3877ac80"

export default script